import { selectMerchant } from "@redux";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ConfirmDone } from "src/Components/icon/ConfirmDone";
import { StyledShowDone } from "./SuccessActivityModalStyled";

interface IProps {
    handleClose: () => void;
}

const tkey = "page.uploadActivity.success";
export const SuccessActivityModal = ({ handleClose }: IProps) => {
    //page redux

    // Translation
    const { t } = useTranslation("translation", { keyPrefix: tkey });
    const { themes } = useSelector(selectMerchant);

    return (
        <StyledShowDone themeColor={themes?.themeColor!}>
            <div className="layout-ex-img">
                <span>
                    <ConfirmDone color={themes?.themeColor ?? "#fff"} />
                </span>
                <div className="title">{t("title")}</div>
                <div className="detail">{t("description")}</div>
            </div>
            <div className="close-popupinvite" onClick={handleClose}>
                <img src="../images/ic-close-invite.svg" alt="" />
            </div>
        </StyledShowDone>
    );
};
